import { render } from "./ViewerSlideshowThumbnails.vue?vue&type=template&id=87f280e2"
import script from "./ViewerSlideshowThumbnails.vue?vue&type=script&lang=js"
export * from "./ViewerSlideshowThumbnails.vue?vue&type=script&lang=js"

import "./ViewerSlideshowThumbnails.vue?vue&type=style&index=0&id=87f280e2&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__